import './App.css'
import React, { useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './bootstrap.min.css'
import './common.scss'
import Layout from './components/Layout'
import { PATH } from './constants/router'
import { AppParamsContextProvider, useAppParamsContext } from './context/AppParamsContext'
import { ROUTERS } from './router'

const AppThemeHandler = ({ children }) => {
  const { appThemeName } = useAppParamsContext()

  useLayoutEffect(() => {
    document.body.setAttribute('data-theme', appThemeName)

    const loadingScreen = document.querySelector('.splash-screen-loading')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  }, [appThemeName])

  return children
}

function App() {
  return (
    <AppParamsContextProvider>
      <AppThemeHandler>
        <Router>
        <Switch>
          {Object.keys(ROUTERS).map((key) => {
            return (
              <Route
                key={ROUTERS[key].path || key}
                exact
                path={ROUTERS[key].path}
                component={(props) => (
                  <React.Suspense fallback={null}>
                    <Layout {...props} Component={ROUTERS[key].component} hideMobileMenu={ROUTERS[key].hideMobileMenu} />
                  </React.Suspense>
                )}
              />
            )
          })}
          <Redirect to={PATH.HOME} />
        </Switch>
      </Router>
      </AppThemeHandler>
    </AppParamsContextProvider>
  )
}

export default App
